module.exports = __webpack_public_path__ + "static/media/Dagim4.031957a2.jpg";